import React from 'react';

import { ConfigProvider as ConfigProvider5 } from 'antd-v5';
import PropTypes from 'prop-types';
import Favicon from 'react-favicon';
import { Provider } from 'react-redux';
import 'scouting-ui/lib/scss/_root.scss';
import sblTheme from 'scouting-ui/lib/themes/sbl';

import { DISABLE_SERVICE_WORKER, isProductionBuild } from '@config/config';
import { CalendarModals } from '@modules/events/components/CalendarModals/CalendarModals';
import FeatureFlagsOverridesBanner from '@modules/featureFlags/components/OverrideBanner';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { OfflineNotification, SessionExpiredModal } from '@offline/components';
import { ResizeWatcher } from '@screen/components';
import { DevWidget, ManualOffline, UnderMaintenance } from '@shared/components';
import { ToastContainer } from '@toasts/components';
import { LoginDataInit, MasqueradeModal } from '@user/components';

import { IntlProvider } from '../../../localization/components';
import { ProgressModals } from '../../../progress/components';
import { ReportParamsModal } from '../../../reports';
import ClientTZ from '../ClientTZ';
import ErrorBoundary from '../ErrorBoundary';
import IconProvider from '../IconsProvider/IconsProvider';
import InitiateSbComSession from '../InitiateSbComSession';
import PageTitle from '../PageTitle';
import RouteSwitcher from '../RouteSwitcher';
import UpdateApp from '../UpdateApp';
import faviconUrl from './favicon.ico';

featureFlags.loadFlags();

function App(props) {
  const { store } = props;
  return (
    <div>
      <Favicon url={faviconUrl} />
      <Provider store={store}>
        <IconProvider>
          <IntlProvider>
            <ConfigProvider5 prefixCls="ant5-sbl" theme={sblTheme}>
              <ErrorBoundary>
                <FeatureFlagsOverridesBanner />
                <UnderMaintenance>
                  <LoginDataInit>
                    <ClientTZ />
                    <PageTitle />
                    <ResizeWatcher />
                    <ToastContainer />
                    <SessionExpiredModal />
                    <ProgressModals />
                    <RouteSwitcher />
                    <InitiateSbComSession />
                    <OfflineNotification />
                    <MasqueradeModal />
                    <ManualOffline />
                    <ReportParamsModal />
                    <CalendarModals />
                    {!!isProductionBuild && !DISABLE_SERVICE_WORKER && (
                      <UpdateApp />
                    )}
                    {!isProductionBuild && <DevWidget />}
                  </LoginDataInit>
                </UnderMaintenance>
              </ErrorBoundary>
            </ConfigProvider5>
          </IntlProvider>
        </IconProvider>
      </Provider>
    </div>
  );
}

App.propTypes = {
  store: PropTypes.object.isRequired,
};

export default App;
